import React from "react";
import { arrowIcon } from "../../../utils/icons";

export const renderArrowNext = (
  clickHandler: () => void,
  hasNext: boolean
): React.ReactNode => {
  return hasNext ? (
    <button
      aria-label="Next slide"
      className="sliderWithTabs__arrow sliderWithTabs__arrow--next"
      onClick={clickHandler}
    >
      {arrowIcon}
    </button>
  ) : null;
};

export const renderArrowPrev = (
  clickHandler: () => void,
  hasNext: boolean
): React.ReactNode => {
  return hasNext ? (
    <button
      aria-label="Previous slide"
      className="sliderWithTabs__arrow sliderWithTabs__arrow--prev"
      onClick={clickHandler}
    >
      {arrowIcon}
    </button>
  ) : null;
};
